import { TmplAstTextAttribute } from '@angular/compiler';
import { getAllLifecycleHooks } from '@angular/compiler/src/lifecycle_reflector';
import {Component, EventEmitter, Input, OnInit, Output,ViewChild} from '@angular/core';
import { SelectMultipleControlValueAccessor } from '@angular/forms';
import { environment } from 'src/environments/environment';
import {ApiService} from '../../../Services/Api.service';


@Component({
  selector: 'chat-box',
  templateUrl: './box.component.html',
  styleUrls: ['./box.component.scss']
})
export class ChatBoxComponent implements OnInit {
  user: any = {};
  defaultImage = 'https://image.shutterstock.com/image-vector/empty-photo-male-profile-gray-260nw-538707310.jpg';
  messageToSend = '';
  fileToSend='';
  showSuccess = false;
  loading = false;
  base64textString = null;
  wait=true;
  filename='';
  icon='';
  error=false;
  error_size=false;
  @Output() closeClicked = new EventEmitter();
  @Output() sendMessage = new EventEmitter();
  @Input() course: any;
  @Input() messages: Array<any>;
  @Input() messagesLoading: EventEmitter<any>;
  @Input() messagesLoaded: EventEmitter<any>;
  @Input() conversation: any;
 
  constructor(private apiService: ApiService) {
  }

  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('user'));
    this.messagesLoading.subscribe(() => {
      this.loading = true;
    });

    this.messagesLoaded.subscribe(() => {
      this.loading = false;
      setTimeout(() => {
        const chatBody = document.querySelector('.chatBody');
        chatBody.scrollTo(0, chatBody.scrollHeight);
      }, 100);
    }); 

   // console.log("messages!!!!!", this)
 
  }

  


  _handleReaderLoaded(readerEvt) {
  
    this.loading=true;
    var file = readerEvt;
    var file_name=this.filename;
    var file_name_resp;

    var binaryString = readerEvt.target.result;
    this.base64textString = btoa(binaryString);
    this.user.file = this.base64textString;
    this.user.file_name=file_name;
    let nombre=file_name;

    this.apiService.post('users/' + this.user.id + '/business/' + this.course.teacher.id + '/upFile', {
        message: 'Hello',
        nombre: file_name,
        file: this.base64textString,
        file2: file,
    })
    .then((response) => {
        
        file_name_resp=response.nombre;
       
        this.wait=false; // que no espere los 5segundos.
        this.addMessage(); //si escriio un msg junto con el adjunto del archivo, mando primero el mens.
        this.wait=true;
        setTimeout(() => {
          this.messageToSend='Arquivo:  <br><i class="'+this.icon+'"></i> <a class="link-a" href="'+environment.baseUrl+'/download/messagesfile/'+file_name_resp+'" target="_blank">'+nombre+'</a>'
          this.addMessage();
        } , 2000);
        
        this.loading=false;
        this.fileToSend='';
    })
    .catch();
 
  
  }
  async delay(ms: number) {
    return new Promise( resolve => setTimeout(resolve, ms) );
  }


  async onFileChanged(evt) {
    var files = evt.target.files;

    var file = files[0]; 
    console.log('Tipo de archivo> ' +file.type);
    //solo tipo archivos
    if ((!file.type.match('image.*'))&&(!file.type.match('video.*'))&&(!file.type.match('audio.*'))&&(!file.type.match('text.*')) &&(!file.type.match('pdf.*'))&&(!file.type.match('document.*'))) {
      this.error=true;
      console.log('error');
      await this.delay(4000);
      this.error=false;
      this.fileToSend='';
      return; //salgo
    }
    if (file.size>21000000){
      this.error_size=true;
      await this.delay(4000);
      this.error_size=false;
      this.fileToSend='';
      return
    }
    this.icon="fa fa-file fa-file-o";
    //cambio icono segun tipo
    if (file.type.match('image.*')){
      this.icon="fa fa-file-image fa-file-image-o";
    }
    if (file.type.match('video.*')){
      this.icon="fa fa-file-video fa-file-video-o";
    }
    if (file.type.match('pdf.*')){
      this.icon="fa fa-file-pdf fa-file-pdf-o";
    }
    if (file.type.match('document.*')){
      this.icon="fa fa-file-word fa-file-word-o";
    }
    if (file.type.match('audio.*')){
      this.icon="fa fa-file-audio fa-file-audio-o";
    }

    this.filename=file.name;
    var reader = new FileReader();
    reader.onload = this._handleReaderLoaded.bind(this);
    reader.readAsBinaryString(file);

  }

  addMessage() {
    if (!this.messageToSend || this.messageToSend.trim() == '') {
      return;
    }

    this.apiService.post('users/' + this.user.id + '/business/' + this.course.teacher.id + '/messages', {
      message: this.messageToSend,
      course_id: this.course.id
    })
      .then((response) => {
        this.sendMessage.emit(response.data);
      })
      .catch();

    if (this.wait){
      this.showSuccess = true;
      setTimeout(() => {
        const chatBody = document.querySelector('.chatBody');
        chatBody.scrollTo(0, chatBody.scrollHeight);
      }, 100);
    
   
      setTimeout(() => {
        this.showSuccess = false;
      } , 5000);

    }

    /*if (this.conversation.instructor == 'Bruna') {
      setTimeout(() => {
        this.conversation.messages.push({
          text: 'Your message was sent. We will communicate shortly.',
          from: 'other',
          date: now.getDay() + '/' + now.getMonth() + ' - ' + now.getHours() + ':' + now.getMinutes()
        });
        setTimeout(() => {
          const chatBody = document.querySelector('.chatBody');
          chatBody.scrollTo(0, chatBody.scrollHeight);
        }, 100);
        setTimeout(() => {
          this.closeClicked.emit(true);
        }, 3000);
      }, 1000);
    } else {

      this.showSuccess = true;
      setTimeout(() => {
        const chatBody = document.querySelector('.chatBody');
        chatBody.scrollTo(0, chatBody.scrollHeight);
      }, 100);

      setTimeout(() => {
        this.closeClicked.emit(true);
        this.showSuccess = false;
      }, 2500);

    }*/

    setTimeout(() => {
      const chatBody = document.querySelector('.chatBody');
      chatBody.scrollTo(0, chatBody.scrollHeight);
    }, 100);
    this.messageToSend = '';
  }

}
